import { IApplicationState } from 'shared/types/redux';

export const selectOffersForAnalytic = (state: IApplicationState) => state.landing.offersForAnalytic;
